export const ds_NewsLayoutBlock_Entry = `
    fragment ds_NewsLayoutBlock_Entry on ds_NewsLayoutBlock_Entry {
        id
        canonicalUid
        news_SelectArticle {
            id
            canonicalUid
        }
        news_Orientation
        news_CardStyle
        news_ImageAspectRatio
        news_ShowTopLabel
        news_TopLabelStyle
        news_ButtonText
        news_ColorTheme
        news_ColorPalette
    }
`